// Advanced-only note kinds are stored under an ordinary type and told apart by this field in `value`.
export const ADVANCED_NOTE_KIND_FIELD = 'advancedNoteKind'

export const INTAKE_NOTE_NUTRITION = 'INTAKE_NOTE_NUTRITION'

export const ADVANCED_NOTE_KIND_LABELS: Partial<Record<string, string>> = {
  [INTAKE_NOTE_NUTRITION]: 'Intake Notes (Nutrition)',
}

export const isNutritionIntakeNote = (value: unknown): boolean =>
  typeof value === 'object' &&
  value !== null &&
  (value as Record<string, unknown>)[ADVANCED_NOTE_KIND_FIELD] === INTAKE_NOTE_NUTRITION
